import { ColorEnum } from '@/constants/color'
import { Icon as IconType } from '@/features/common/components/Overview/parts/ProductItem/parts/OptionRow/types'
import MinusIcon from '@/features/ui/icons/components/MinusIcon'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface IconProps {
    icon: IconType
}

const Icon: FC<IconProps> = ({ icon }) => {
    const { styles } = useStyles(stylesheet, { icon })

    return (
        <View style={styles.iconContainer}>
            {icon === 'plus' ? (
                <PlusIcon fill={ColorEnum.EMERALD_700} width={16} height={16} />
            ) : (
                <MinusIcon fill={ColorEnum.BRICK_600} width={16} height={16} />
            )}
        </View>
    )
}

const stylesheet = createStyleSheet({
    iconContainer: {
        height: 16,
        width: 16,
        borderRadius: 4,
        alignItems: 'center',
        justifyContent: 'center',
        variants: {
            icon: {
                plus: {
                    backgroundColor: ColorEnum.EMERALD_200,
                },
                minus: {
                    backgroundColor: ColorEnum.BRICK_200,
                },
            },
        },
    },
})

export default Icon
